module.exports = __webpack_public_path__ + "static/media/acceuil_1.a27fcf11.jpg";